function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $app } from "../play-candidato-mod";
import { TestService } from "src/_candidato/priv/services/test.service";
import { AccesoDatos } from "src/_candidato/comun/services/acceso-datos";
import "./play-app.scss";
var SideBarCtrl = /*#__PURE__*/function () {
  function SideBarCtrl() {
    _classCallCheck(this, SideBarCtrl);
    _defineProperty(this, "$visible", false);
  }
  return _createClass(SideBarCtrl, [{
    key: "toggle",
    value: function toggle() {
      this.$visible = !this.$visible;
    }
  }]);
}();
var PlayAppComponentCtrl = /*#__PURE__*/function () {
  PlayAppComponentCtrl.$inject = ["$log", "$timeout", "TestService", "AccesoDatos"];
  function PlayAppComponentCtrl($log, $timeout, TestService, AccesoDatos) {
    _classCallCheck(this, PlayAppComponentCtrl);
    _defineProperty(this, "$visible", true);
    _defineProperty(this, "editor", {
      panel: new SideBarCtrl(),
      menu: new SideBarCtrl(),
      formular: new SideBarCtrl()
    });
    this.$log = $log;
    this.$timeout = $timeout;
    this.TestService = TestService;
    this.AccesoDatos = AccesoDatos;
    this.ts2 = new Date();
  }
  return _createClass(PlayAppComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PlayAppComponentCtrl] onInit');

      // this.UniciService.empezarTarea(this.nuevaTarea())
    }

    // private nuevaTarea(): TareaDef {

    //     return TareaDef.fromDef({
    //         destinos: [],
    //         notas: "kaakkak"
    //     })
    // } 
  }, {
    key: "nueva",
    value: function nueva() {
      var _this = this;
      this.$timeout(function () {
        return _this.$visible = true;
      }, 50);
      this.TestService.testFormularios().then(function (datos) {
        return _this.$log.info("=====> ", datos);
      });
      this.AccesoDatos.menuResource.findAll().then(function (datos) {
        return _this.$log.info("=====> findAll ", datos);
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {}
  }]);
}();
$app.component("playApp", {
  bindings: {},
  controller: PlayAppComponentCtrl,
  template: require("./play-app.component.html")
});